// Include your assignment 1 below.
// Read the PDF for instruction on what to do.
// Ensure that you look at the "Marking Key" section of the PDF
// to not lose any marks.
// include bootstrap

const $2f850977971ce40b$var$API_KEY = "62ac1322ec53c62c861a98010efb5634";
const $2f850977971ce40b$export$ce1081f0c9899666 = async (cityName)=>{
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${$2f850977971ce40b$var$API_KEY}`;
    const response = await fetch(url);
    const data = await response.json();
    try {
        // console.log('response.status:', response.status);
        if (response.status === 404) throw new Error("Please enter a valid city name");
        else // console.log("returning data");
        return data;
    } catch (error) {
        // console.log('Caught an error:', error.message);
        const weatherContainer = document.querySelector(".weather-container");
        setTimeout(()=>{
            weatherContainer.innerHTML = `<div class="border border-danger align-middle"><h5 class="text-center text-danger">${error.message}</h5></div>`;
        }, 500); // Delay of 0.5 seconds
    }
};


/*
HTML Structure 


Note: I'm sure you've read the PDF but there will be no marks given
for using innerHTML. 

<div class="mt-2 card" >
  <div class="card-body">
    <h5 class="card-title">CITY_NAME_HERE, COUNTRY_CODE_HERE</h5>
    <h6 class="card-subtitle mb-2 text-muted">CURRENT_WEATHER_DEGREES_HERE</h6>
    <p class="card-text">WEATHER_DESCRIPTION_HERE</p>
  </div>
</div>

*/ // renderWeather function with an argument of weather and the element to append to which has a class of weather-container
const $92772a505c9e57d9$export$6725c38767fd6246 = (weather_reply, element)=>{
    const weatherSearchInput = document.getElementById("weather-search-input");
    weatherSearchInput.value = "";
    const weatherContainer = document.querySelector(element);
    weatherContainer.classList.add("mt-2", "card", "card-body");
    weatherContainer.innerHTML = "";
    const cityNameElement = document.createElement("h5");
    cityNameElement.classList.add("card-title");
    cityNameElement.textContent = weather_reply.name + ", " + weather_reply.sys.country;
    const temperatureElement = document.createElement("p");
    temperatureElement.classList.add("card-subtitle", "mb-2", "text-muted");
    temperatureElement.textContent = `Temperature: ${Math.round(weather_reply.main.temp - 273.15)}\xb0C`;
    const descriptionElement = document.createElement("p");
    descriptionElement.classList.add("card-text");
    descriptionElement.textContent = `Description: ${weather_reply.weather[0].description.charAt(0).toUpperCase()}${weather_reply.weather[0].description.slice(1)}`;
    const humidityElement = document.createElement("p");
    humidityElement.textContent = `Humidity: ${weather_reply.main.humidity}%`;
    weatherContainer.appendChild(cityNameElement);
    weatherContainer.appendChild(temperatureElement);
    weatherContainer.appendChild(descriptionElement);
    weatherContainer.appendChild(humidityElement);
};


const $e5e6023659c13c1d$var$searchClicked = (e)=>{
    e.preventDefault();
    const cityInput = document.getElementById("weather-search-input");
    const cityName = cityInput.value.trim();
    if (cityName) (0, $2f850977971ce40b$export$ce1081f0c9899666)(cityName).then((weatherInfo)=>(0, $92772a505c9e57d9$export$6725c38767fd6246)(weatherInfo, ".weather-container")).catch((error)=>console.error("Error in renderWeather:", error));
    else alert("Please enter a valid city name");
};
document.getElementById("weather-search-button").addEventListener("click", $e5e6023659c13c1d$var$searchClicked);


//# sourceMappingURL=index.0919b29e.js.map
